const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {	
			ZZ_ONCOR: {
				name: ['(客製)薪資', '(客製)薪資', '(客製)薪資'],
				children: {
					ZZ_ONCOR_PB10410: {
						name: ['(客製)輪班津貼計算', '(客製)輪班津貼計算', '(客製)輪班津貼計算'],
						url: '/zz_oncor_pb10410',
						hint: [],
					},
				},
			},
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};